import { forwardRef, Ref } from 'react';
// eslint-disable-next-line no-restricted-imports
import { NavAppContent as ArcNavAppContent, NavAppContentProps } from 'arc';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { DEFAULT_FR_NAV_APP_CONTENT_STYLES } from './constants';

export const NavAppContent = forwardRef(function (
    props: NavAppContentProps,
    ref?: Ref<HTMLDivElement>
) {
    const { isFirstResponder } = useApplicationType();
    const { style, children, ...remainingProps } = props;

    return (
        <ArcNavAppContent
            ref={ref}
            style={{
                ...(isFirstResponder ? DEFAULT_FR_NAV_APP_CONTENT_STYLES : {}),
                ...style,
            }}
            {...remainingProps}
        >
            {children}
        </ArcNavAppContent>
    );
});
